import { GLOBAL_Client_Api_URL } from "../Models/global";
const apiShopBaseUrl = `${GLOBAL_Client_Api_URL}`;
const apiKey=process.env.REACT_APP_API_Key;
var token = localStorage.getItem("token");
const apiService = {
   fetchData: async (endpoint: any, data = {}) => {
    try {
      debugger;
      const url = `${apiShopBaseUrl}/${endpoint}`; 
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-API-Key": apiKey,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
  console.log("Status:", response.status);
  console.log("Status Text:", response.statusText);
  console.log("Response:", response);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      return await response.json();
    } catch (error) {
      console.error("Post data error:", error);
      throw error;
    }
  },
    fetchGetData: async (endpoint: any, params = {}) => {
    try {

      const queryString = new URLSearchParams(params).toString();
      const url = queryString
        ? `${apiShopBaseUrl}/${endpoint}?${queryString}`
        : `${apiShopBaseUrl}/${endpoint}`;
      const response = await fetch(url, {
        method: "GET", 
        headers: {
       "X-API-Key": apiKey,
          "Content-Type": "application/json",
        },
      }); 
      if (!response.ok) throw new Error("Network response was not ok");
      return await response.json();
    } catch (error) {
      console.error("Fetch data error:", error);
      throw error;
    }
  }, 
  
  addData: async (endpoint: any, data: any) => {
    try {
      var urlRoot = apiShopBaseUrl;
      const response = await fetch(`${urlRoot}/${endpoint}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`, // Include your token here
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      }); 
      if (!response.ok) throw new Error("Network response was not ok");
      return await response.json();
    } catch (error) {
      console.error("Add data error:", error);
      throw error;
    }
  },
  updateData: async (endpoint: any, data: any) => {
    try {
      var urlRoot = apiShopBaseUrl;
      const response = await fetch(`${urlRoot}/${endpoint}`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`, // Include your token here
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) throw new Error("Network response was not ok");
      return await response.json();
    } catch (error) {
      console.error("Update data error:", error);
      throw error;
    }
  },
  updateByParms: async (endpoint: any, params = {}) => {
    try {
      var urlRoot = apiShopBaseUrl;
      const queryString = new URLSearchParams(params).toString();
      const url = queryString
        ? `${urlRoot}/${endpoint}?${queryString}`
        : `${urlRoot}/${endpoint}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`, // Include your token here
        },
      });
      if (!response.ok) throw new Error("Network response was not ok");
      return await response.json();
    } catch (error) {
      console.error("Delete data error:", error);
      throw error;
    }
  },
  deleteData: async (endpoint: any, params = {}) => {
    try {
      var urlRoot = apiShopBaseUrl;
      const queryString = new URLSearchParams(params).toString();
      const url = queryString
        ? `${urlRoot}/${endpoint}?${queryString}`
        : `${urlRoot}/${endpoint}`;

      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`, // Include your token here
        },
      });

      if (!response.ok) throw new Error("Network response was not ok");
      return await response.json();
    } catch (error) {
      console.error("Delete data error:", error);
      throw error;
    }
  },
};
export default apiService;
